import(/* webpackMode: "eager" */ "C:\\Users\\steal\\Documents\\1. Projects\\iks-site\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\steal\\Documents\\1. Projects\\iks-site\\node_modules\\next\\dist\\client\\image-component.js");
